export default __webpack_public_path__ + "static/arc-42e42d7c45c44c72d9865101fdb46050.png";